import { useQuery } from '@tanstack/react-query';
import getRulesetDetail from 'Api/schedule-generate/getRulesetDetail';
import getRulesetDetailRequest from './model/request/getRulesetDetailRequest';
import getRulesetDetailResponse from './model/response/getRulesetDetailResponse';
import { useScheduleGenerateState } from 'View/schedule-generate/state';

const useGetRulesetDetail = (queryParams) => {
  const { rulesetId } = queryParams;
  const { updateState } = useScheduleGenerateState();
  return useQuery({
    queryKey: ['ruleset-detail-generate', rulesetId?.id],
    queryFn: async () => {
      const queries = getRulesetDetailRequest(queryParams);

      const response = await getRulesetDetail(queries);

      const result = getRulesetDetailResponse(response);

      updateState({ hostsInRulesets: result.users });

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: !!rulesetId?.id,
  });
};

export default useGetRulesetDetail;
